import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'get'

export default class OspreyTemplatesGetThumbnails extends BaseAction {
    constructor(dataKey) {
        const id = '8928967e-1a5d-4af1-974e-305892ca7084'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getThumbnails(params) {
        this.params = Object.assign({
            fields: 'id,thumbnailUrl',
            pc: 8,
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-get-thumbnails.js